import React from 'react';

import { IIconProps, TIconType } from '../interface';

const AlarmActiveIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<g
				clipPath='url(#clip0_5186_3456)'
			>
				<path
					d='M21.3094 7.51875L16.4813 2.69063C16.1999 2.41003 15.8192 2.2517 15.4219 2.25H8.57812C8.18077 2.2517 7.80011 2.41003 7.51875 2.69063L2.69063 7.51875C2.41003 7.80011 2.2517 8.18077 2.25 8.57812V15.4219C2.2517 15.8192 2.41003 16.1999 2.69063 16.4813L7.51875 21.3094C7.80011 21.59 8.18077 21.7483 8.57812 21.75H15.4219C15.8192 21.7483 16.1999 21.59 16.4813 21.3094L21.3094 16.4813C21.59 16.1999 21.7483 15.8192 21.75 15.4219V8.57812C21.7483 8.18077 21.59 7.80011 21.3094 7.51875V7.51875ZM11.25 7.5C11.25 7.30109 11.329 7.11032 11.4697 6.96967C11.6103 6.82902 11.8011 6.75 12 6.75C12.1989 6.75 12.3897 6.82902 12.5303 6.96967C12.671 7.11032 12.75 7.30109 12.75 7.5V12.75C12.75 12.9489 12.671 13.1397 12.5303 13.2803C12.3897 13.421 12.1989 13.5 12 13.5C11.8011 13.5 11.6103 13.421 11.4697 13.2803C11.329 13.1397 11.25 12.9489 11.25 12.75V7.5ZM12 17.25C11.7775 17.25 11.56 17.184 11.375 17.0604C11.19 16.9368 11.0458 16.7611 10.9606 16.5555C10.8755 16.35 10.8532 16.1238 10.8966 15.9055C10.94 15.6873 11.0472 15.4868 11.2045 15.3295C11.3618 15.1722 11.5623 15.065 11.7805 15.0216C11.9988 14.9782 12.225 15.0005 12.4305 15.0856C12.6361 15.1708 12.8118 15.315 12.9354 15.5C13.059 15.685 13.125 15.9025 13.125 16.125C13.125 16.4234 13.0065 16.7095 12.7955 16.9205C12.5845 17.1315 12.2984 17.25 12 17.25Z'
					fill={props?.color || '#4D4DB3'}
				/>
			</g>
			<defs>
				<clipPath
					id='clip0_5186_3456'
				>
					<rect
						fill='white'
						height='24'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default AlarmActiveIcon;
